import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDuiV5F2YRyuaBGUwuc69NWCV1uG2n6vj8",
  authDomain: "dotanddash-f3649.firebaseapp.com",
  projectId: "dotanddash-f3649",
  storageBucket: "dotanddash-f3649.firebasestorage.app", 
  messagingSenderId: "406430300949",
  appId: "1:406430300949:web:3cf73416c383096d56471c",
  measurementId: "G-S189LK18P7"
};
// ✅ Initialize app
const app = initializeApp(firebaseConfig);

// ✅ Export auth instance
export const auth = getAuth(app);